import style from "./index.module.scss";

export type StatCardColor = "blue" | "teal" | "purple" | "orange" | "green";

interface IProps {
  icon: string; // Font Awesome 5 class, e.g. "fa-wallet" (styles/font-awesome.css - already bundled)
  label: string;
  value: string;
  subValue?: string;
  color?: StatCardColor;
}

// Reusable KPI card: icon badge + label + value, reusing the project's
// already-global .icon-element circle (src/styles/index.scss) instead of
// introducing a new icon style. Matches the mockup's stat-card layout -
// including a distinct fill color per icon badge (mockup: blue/$, teal/
// wallet, purple/people, orange/worker, teal/coins - each card has its own
// color, not one uniform tone).
export function StatCard({ icon, label, value, subValue, color = "blue" }: IProps) {
  return (
    <div className={style.statCard}>
      <div
        className={`icon-element icon-element-sm ${style.statCard__icon} ${style[color]}`}
      >
        <i className={`fal ${icon}`} />
      </div>
      <div className={style.statCard__body}>
        <p className={style.statCard__label}>{label}</p>
        <span className={style.statCard__value}>{value}</span>
        {subValue && <span className={style.statCard__sub}>{subValue}</span>}
      </div>
    </div>
  );
}
